import * as PIXI from "pixi.js";

import Tengoku from "./tengoku/main";
import Makyou from "./makyou/main";

export default class IntroCanvas {
    constructor() {
        this._init();
    }

    render(key) {
        this.key = key;
        this._loadAssets();
    }

    _init() {
        this.isContentUpdate = false;

        this.assets = {
            tengoku_bg: "/assets/img/common/bg/bg_wide_w.jpg",
            makyou_bg: "/assets/img/common/bg/bg_wide.jpg",
        };

        this.app = null;
        this.key = null;
        this.textures = null;
    }

    _loadAssets() {
        const keys = [];

        Object.keys(this.assets).forEach((key) => {
            PIXI.Assets.add(key, this.assets[key]);
            keys.push(key);
        });

        const texPromise = PIXI.Assets.load(keys);
        texPromise.then((textures) => {
            this.textures = textures;
            this._createPixi();
        });
    }

    _createPixi() {
        this.app = new PIXI.Application({
            width: window.innerWidth,
            height: window.innerHeight,
            backgroundColor: 0x000000,
            backgroundAlpha: 0,
            view: document.querySelector(".js-canvas"),
            transparent: true,
        });

        this._changeIntro();

        this._tick();
    }

    _tick() {
        this.content.update();

        if (STORAGE.data.isRaf) {
            requestAnimationFrame(this._tick.bind(this));
        } else {
            this._removeApp();
        }
    }

    _removeApp() {
        const $canvas = document.querySelector(".js-canvas");
        $canvas.remove();
        //先にブレンドモードの解除のみ行う
        this.content.onDestroy();

        setTimeout(() => {
            this.app.destroy(false, { children: true, texture: true, baseTexture: true });
        }, 100);
    }

    _changeIntro() {
        if (this.key === "tengoku") {
            this.content = new Tengoku(this.app, this.textures);
        } else {
            this.content = new Makyou(this.app, this.textures);
        }
    }
}
